import { CSSObjectWithLabel, StylesConfig } from 'react-select'

type PositionType = 'absolute' | 'relative' | 'fixed' | 'static' | 'sticky'

export interface CustomStyles {
  control?: CSSObjectWithLabel
  valueContainer?: CSSObjectWithLabel
  indicatorsContainer?: CSSObjectWithLabel
  input?: CSSObjectWithLabel
  menu?: Partial<CSSObjectWithLabel & { position: PositionType }>
  menuList?: CSSObjectWithLabel
}

export const countrySelectCustomStyles = (
  customStyles?: CustomStyles,
  menuPlacement?: 'top' | 'bottom',
): StylesConfig => ({
  control: (base) => ({
    ...base,
    boxShadow: 'none',
    cursor: 'pointer',
    minHeight: '24px',
    height: '24px',
    marginRight: '8px',
    ...customStyles?.control,
  }),

  valueContainer: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    padding: '0',
    ...customStyles?.valueContainer,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    padding: 0,
    marginLeft: -8,
    ...customStyles?.indicatorsContainer,
  }),

  input: (base) => ({
    ...base,
    display: 'none',
    ...customStyles?.input,
  }),

  menu: (base) => ({
    ...base,
    borderRadius: '32px',
    padding: 0,
    margin: 0,
    width: '230px',
    height: '280px',
    boxShadow: '0 0 10px rgba(0,0,0,0.05)',
    position: 'absolute',
    left: menuPlacement === 'top' ? '0' : '0',
    bottom: menuPlacement === 'top' ? '0' : '-100%',
    transform: menuPlacement === 'top' ? 'translateY(-350px)' : 'translateY(10px)',
    zIndex: 8,
    ...customStyles?.menu,
    backgroundColor: 'transparent',
    overflow: 'hidden',
  }),

  menuList: (base) => ({
    ...base,
    padding: 0,
    margin: 0,
    maxHeight: '280px',
    overflowY: 'auto',
    overflowX: 'hidden',
    zIndex: 8,
    backgroundColor: 'white',
    borderRadius: 'inherit',
    boxShadow: '0 0 10px rgba(0,0,0,0.05)',
    ...customStyles?.menuList,
  }),
})
